<template>
  <MakerCartGuideLayout
    pageTitle="Facilitating a Maker Activity"
    heroImage="/images/maker-cart-guide/frame-1000006697.png"
    previousUrl="/makercart/guide/9"
    nextUrl="/makercart/guide/11"
  >
    <div class="x-section">
      <div class="x-section-content">
        <h2 class="x-section-title">Before Activity</h2>
        <div class="x-section-body">
          <ul>
            <li class="fs-12">
              Before conducting the Maker Cart Activity, we highly recommended
              that the facilitator is familiar and informed with the activity.
              An alternative would be to participate in the maker activity and
              explore with the student.
            </li>
            <li class="fs-12">
              You may place the Activity Poster in a visible location to be
              easily viewed by the students from different parts of the class.
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="x-section">
      <div class="x-section-content">
        <h2 class="x-section-title">During Activity</h2>
        <div class="x-section-body">
          <ul>
            <li class="fs-12">
              Advise the students to consider and plan ahead. Encourage them to
              have a clear idea of the materials and quantities needed before
              taking the materials, but do not restrict them from using other
              materials than the suggested ones. (Use the budget sheet to manage
              the material used)
            </li>
            <li class="fs-12">
              Ensure that the students keep their surroundings clean during the
              prototyping process.
            </li>
            <li class="fs-12">
              Advise caution when sharp tools like scissors or cardboard knife.
            </li>
            <li class="fs-12">
              Observe the student's ideation and prototyping process, do not
              physically help the students to complete the prototype.
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="x-section">
      <div class="x-section-content">
        <h2 class="x-section-title">After Activity</h2>
        <div class="x-section-body">
          <ul>
            <li class="fs-12">
              Clean up the surrounding workspace, ensure students store unused
              materials neatly back on the Maker Cart.
            </li>
            <li class="fs-12">
              Allow the students to reflect on the making process and encourage
              them to consider possible improvements even after the activity has
              ended.
            </li>
            <li class="fs-12">
              Encourage the students to visit the space often to improve and
              develop their prototypes.
            </li>
          </ul>
        </div>
      </div>
    </div>
  </MakerCartGuideLayout>
</template>

<script setup>
import MakerCartGuideLayout from "@/components/maker-cart/MakerCartGuideLayout.vue";
</script>

<style scoped>
:deep(.x-right-content) {
  gap: 0px;
}
</style>
